// extracted by mini-css-extract-plugin
export var statItem = "_kj-1";
export var statsRow = "_kj-0";